import { graphql } from '@/generated/gql';

export const RULE_LIST_QUERY = graphql(/* GraphQL */ `
  query RuleList($offset: Int, $limit: Int, $filter: TsrctQueryBuilderQuery, $order: [TsrctRuleListSourcingOrder!]) {
    tesseract {
      rules {
        sourcing(offset: $offset, limit: $limit, filter: $filter, order: $order) {
          nodes {
            id
            name
            variant
            sequenceNumber
            status
            createdAt
            updatedAt
            accountingAreaIds
            commodityGroupIds
            organizationIds
            sourceSystemIds
            responsibleIds
          }
          totalCount
        }
      }
    }
  }
`);
